import React, { useCallback, useMemo } from 'react';
import classNames from 'classnames';
import { Select, SelectableOption } from '@moda/om';
import { LineItem } from '../../../hooks/useCart/cart.rest';

import './LineItemSizeSelector.scss';

type Props = {
  item: LineItem;
  onChange: (skuId: number) => void;
};

export const LineItemSizeSelector: React.FC<Props> = ({
  item: {
    type,
    attributes: { inventory, isProductAvailable, error }
  },
  onChange
}) => {
  const selectedSkuId = useMemo(() => inventory.find(({ selected }) => selected)?.id, [inventory]);

  const handleChange = useCallback(
    (id: string) => selectedSkuId !== Number(id) && onChange(Number(id)),
    [onChange, selectedSkuId]
  );

  const options: SelectableOption[] = useMemo(
    () =>
      inventory.map(({ size, id, disabled }) => ({
        label: size,
        value: String(id),
        disabled
      })),
    [inventory]
  );

  return (
    <Select
      className={classNames('LineItemSizeSelector', {
        'LineItemSizeSelector--error': error?.type === 'SHORT_SIZE_SOLD_OUT_MESSAGE'
      })}
      disabled={inventory.length < 2 || (type === 'cart_items' && !isProductAvailable)}
      options={options}
      onChange={handleChange}
      value={selectedSkuId?.toString()}
      label="Size"
      data-testid="lineItemSizeSelector"
      idRef={selectedSkuId?.toString()}
    />
  );
};
